import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PerinHealthGrid from '../../components/PerinHealthGrid';
import { resetProgramState, setProgramState } from './AddProgramSlice';
import { resetModalitiesState } from './ModalitiesSlice';
import { setSelectedRows, setSelectAll } from '../../components/PerinHealthGridSlice';
import styles from '../ManagementPages.module.css';
import { useNavigate } from 'react-router-dom';
import useAxios from '../../services/AxiosConfig';
import FilterManagementView from '../../components/FilterManagementView';
import { closeModal } from '../../components/PerinHealthModelSlice';
import { showAlert } from '../../components/PerinHealthAlertSlice';
import { setListValue } from './SetupListsSlice';
import { formatDateString } from '../../utils/dateUtils';


const ProgramManagement = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = useSelector((state) => state.userInfo.id);
    const userDateFormat = useSelector((state) => state.userInfo.dateFormat);
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const httpService = useAxios(axiosConfig.envURL);
    const perinHealthGrid = useSelector((state) => state.perinHealthGrid);
    let selectedRows = perinHealthGrid.selectedRows;

    const headers = [
        { key: 'id', label: "ID"},
        { key: 'name', label: "Program Name"},
        { key: 'duration', label: "Program Duration"},
        { key: 'date_created', label: "Date Created"},
        { key: 'groupName', label: "Group"},
    ];

    const [programs, setPrograms] = useState([]);

    const getProgramsById = () => {
        httpService.get(`careprogram/list/${userId}`)
        .then((responseData) => {
            if (Array.isArray(responseData.data.data)) {
                const formattedPrograms = responseData.data.data.map(program => ({
                    ...program,
                    date_created: program.date_created ? formatDateString(program.date_created, userDateFormat) : ''
                }));
                setPrograms(formattedPrograms);
            } else {
                console.error('Invalid data format:');
                setPrograms([]);
            }
        })
        .catch((err) => {
            console.log(err);
            setPrograms([]);
        });
    };

    useEffect(() => {
        dispatch(resetProgramState());
        dispatch(resetModalitiesState());
        getProgramsById();
    }, []);

    useEffect(() => {
        if (userDateFormat) {
            getProgramsById();
        }
    }, [userDateFormat]);

    const fetchItems = () => {
        httpService.get(`content/list/${userId}`)
        .then((responseData) => {
            if (Array.isArray(responseData.data.data)) {
                dispatch(setListValue({key:"content", value:responseData.data.data}));
            } else {
                console.error('Invalid data format:');
            }
        })
        .catch((err) => {
            console.log(err);
        });

        httpService.get(`device/group/${userId}`)
            .then((responseData) => {
                if (Array.isArray(responseData.data.data)) {
                    const deviceData = responseData.data.data;
                    for (const device of deviceData) {
                        device.listLabel = `${device.model} - ${device.manufacturer}`
                    }
                    dispatch(setListValue({key:"devices", value:deviceData}));
                } else {
                    console.error('Invalid data format:');
                }
            })
            .catch((err) => {
                console.log(err);
        });

        httpService.get(`questionnaire/list/${userId}`)
        .then((responseData) => {
            if (Array.isArray(responseData.data.data)) {
                dispatch(setListValue({key:"questionnaires", value:responseData.data.data}));
            } else {
                console.error('Invalid data format:');
            }
        })
        .catch((err) => {
            console.log(err);
        });

    }
    
    const onAddProgramHandler = () => {
        fetchItems();
        navigate(`/add-program`);
    };

    const onRowClickHandler = (rowItem) => {
        fetchItems();
        dispatch(setProgramState(rowItem));
        navigate(`/add-program`);
    };

    const onDeleteHandler = () => {
        const deletePromises = selectedRows.map((program) => {
            const id = program.id;
            return httpService.delete(`careprogram/${id}`);
        });

        Promise.all(deletePromises)
            .then((responses) => {
                dispatch(setSelectedRows([]));
                dispatch(setSelectAll(false));
                getProgramsById();
                dispatch(closeModal());
                dispatch(
                    showAlert({
                        header: "Success",
                        message: `Successfully deleted programs`,
                        type: 'success'
                    })
                );
            })
            .catch((errors) => {
                console.error('Error deleting rows:', errors);
                dispatch(
                    showAlert({
                        header: "Error",
                        message: `Error deleting programs`,
                        type: 'danger'
                    })
                );
                
            });
    };

    return (
        <div className={styles.MiddleContent}>
            <FilterManagementView
                isOrganization={true}
                isGroup={true}
                isSubGroup={false}
                isTeam={false}
                addButtonLabel='Add Program'
                onAddHandler={onAddProgramHandler}
                onDeleteHandler={onDeleteHandler} 
                modelHeader='Remove Program?'
            />
            <div className={styles.GridContainer}>
                <PerinHealthGrid
                    dataList={programs}
                    headers={headers}
                    showCheckbox={true}
                    showEditIcon={true}
                    onRowClick={onRowClickHandler}
                    onDeleteRow={onDeleteHandler}
                    showHeaderFilter={true}
                    gridHeight="100%"
                />
            </div>
        </div>
    )
}

export default ProgramManagement;
